import { FORM_ACTION, getRoutes } from '@ui-framework/index';
import ServiceProvidersList from './pages/ServiceProvidersList/index';
import CompanyInfoCreate from './pages/CompanyInfo/create/index';
import CompanyInfoEdit from './pages/CompanyInfo/edit/index';
import UsersList from './pages/Users/list/index';
import UserCreate from './pages/Users/create/index';
import UserEdit from './pages/Users/edit/index';
import LocationsList from './pages/Location/list/index';
import LocationCreate from './pages/Location/create/index';
import LocationDetailsEdit from './pages/Location/edit/index';
import LocationSkills from './pages/Location/skills/index';
import Setup from './pages/SetUp/index';
import Performance from './pages/Performance';
import DispatchSettings from './pages/SystemSettings/DispatchSetting';
import InsightSettings from './pages/SystemSettings/InsightSetting';
import APIKeysSettings from './pages/SystemSettings/ApiKeysSetting';
import ClaimsSetting from './pages/SystemSettings/ClaimsSetting';
import LocationClaimsSetting from './pages/Location/claimsSetting';
import LocationSetup from './pages/Location/setup/index';
import LocationServiceAreaList from './pages/Location/servicearea/list/index';
import LocationServiceAreaCreate from './pages/Location/servicearea/create/index';
import LocationServiceAreaDetails from './pages/Location/servicearea/edit/index';
import LocationServiceAreaMap from './pages/Location/servicearea/map/index';
import LocationServiceAreaRate from './pages/Location/servicearea/rate/index';
import LocationPerformance from './pages/Location/performance/index';
import AvailabilityLiveCalendar from './pages/Availability/LiveCalendar/index';
import AvailabilityDefaultSchedules from './pages/Availability/DefaultSchedules/index';
import AvailabilitySpecialSchedules from './pages/Availability/SpecialSchedules/index';
import LocationAvailabilityLiveCalendar from './pages/Location/availability/LiveCalendar/index';
import LocationAvailabilityDefaultSchedules from './pages/Location/availability/DefaultSchedules/index';
import LocationAvailabilitySpecialSchedules from './pages/Location/availability/SpecialSchedules/index';
import Skills from './pages/Skills/index';
import schema from './schemas/routes.json';
import ErrorPage, { ERROR_PAGE_TYPE } from '../ErrorPage';

import {
  ServiceProviderCreateFormStore,
  ServiceProviderEditFormStore,
  ServiceProviderListStore,
  ServiceProviderSearchFormStore,
} from './store';

const Pages = ProtectedRoute => ({
  ServiceProvidersList: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceProvidersList}
    />
  ),
  CompanyInfoCreate: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={CompanyInfoCreate}
    />
  ),
  CompanyInfoEdit: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={CompanyInfoEdit}
    />
  ),
  UsersList: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={UsersList}
    />
  ),
  UserCreate: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={UserCreate}
    />
  ),
  UserEdit: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={UserEdit}
    />
  ),
  LocationsList: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={LocationsList}
    />
  ),
  LocationCreate: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={LocationCreate}
    />
  ),
  LocationDetailsEdit: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={LocationDetailsEdit}
    />
  ),
  LocationSkills: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={LocationSkills}
    />
  ),
  LocationSetup: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={LocationSetup}
    />
  ),
  LocationServiceAreaList: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={LocationServiceAreaList}
    />
  ),
  LocationServiceAreaCreate: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={LocationServiceAreaCreate}
    />
  ),
  LocationServiceAreaDetails: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={LocationServiceAreaDetails}
    />
  ),
  LocationServiceAreaMap: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={LocationServiceAreaMap}
    />
  ),
  LocationServiceAreaRate: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={LocationServiceAreaRate}
    />
  ),
  LocationClaimsSetting: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={LocationClaimsSetting}
    />
  ),
  Skills: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={Skills}
    />
  ),
  Setup: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={Setup}
    />
  ),
  SystemSettings: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ClaimsSetting}
    />
  ),
  ClaimsSetting: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ClaimsSetting}
    />
  ),
  DispatchSettings: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={DispatchSettings}
    />
  ),
  InsightSettings: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={InsightSettings}
    />
  ),
  APIKeysSettings: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={APIKeysSettings}
    />
  ),
  Performance: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={Performance}
    />
  ),
  LocationPerformance: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={LocationPerformance}
    />
  ),
  AvailabilityLiveCalendar: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={AvailabilityLiveCalendar}
    />
  ),
  AvailabilityDefaultSchedules: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={AvailabilityDefaultSchedules}
      componentProps={{ mode: FORM_ACTION.LIST }}
    />
  ),
  AvailabilityDefaultSchedulesCreate: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={AvailabilityDefaultSchedules}
      componentProps={{ mode: FORM_ACTION.CREATE }}
    />
  ),
  AvailabilityDefaultScheduleView: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={AvailabilityDefaultSchedules}
      componentProps={{ mode: FORM_ACTION.VIEW }}
    />
  ),
  AvailabilityDefaultScheduleEdit: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={AvailabilityDefaultSchedules}
      componentProps={{ mode: FORM_ACTION.EDIT }}
    />
  ),
  AvailabilitySpecialSchedules: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={AvailabilitySpecialSchedules}
      componentProps={{ mode: FORM_ACTION.LIST }}
    />
  ),
  AvailabilitySpecialSchedulesCreate: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={AvailabilitySpecialSchedules}
      componentProps={{ mode: FORM_ACTION.CREATE }}
    />
  ),
  AvailabilitySpecialScheduleView: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={AvailabilitySpecialSchedules}
      componentProps={{ mode: FORM_ACTION.VIEW }}
    />
  ),
  AvailabilitySpecialScheduleEdit: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={AvailabilitySpecialSchedules}
      componentProps={{ mode: FORM_ACTION.EDIT }}
    />
  ),
  LocationAvailabilityLiveCalendar: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={LocationAvailabilityLiveCalendar}
    />
  ),
  LocationAvailabilityDefaultSchedules: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={LocationAvailabilityDefaultSchedules}
      componentProps={{ mode: FORM_ACTION.LIST }}
    />
  ),
  LocationAvailabilityDefaultSchedulesCreate: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={LocationAvailabilityDefaultSchedules}
      componentProps={{ mode: FORM_ACTION.CREATE }}
    />
  ),
  LocationAvailabilityDefaultScheduleView: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={LocationAvailabilityDefaultSchedules}
      componentProps={{ mode: FORM_ACTION.VIEW }}
    />
  ),
  LocationAvailabilityDefaultScheduleEdit: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={LocationAvailabilityDefaultSchedules}
      componentProps={{ mode: FORM_ACTION.EDIT }}
    />
  ),
  LocationAvailabilitySpecialSchedules: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={LocationAvailabilitySpecialSchedules}
      componentProps={{ mode: FORM_ACTION.LIST }}
    />
  ),
  LocationAvailabilitySpecialSchedulesCreate: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={LocationAvailabilitySpecialSchedules}
      componentProps={{ mode: FORM_ACTION.CREATE }}
    />
  ),
  LocationAvailabilitySpecialScheduleView: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={LocationAvailabilitySpecialSchedules}
      componentProps={{ mode: FORM_ACTION.VIEW }}
    />
  ),
  LocationAvailabilitySpecialScheduleEdit: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={LocationAvailabilitySpecialSchedules}
      componentProps={{ mode: FORM_ACTION.EDIT }}
    />
  ),
});

const routes = ({ ProtectedRoute, BubbleRouteError }) =>
  getRoutes({
    schema,
    ProtectedRoute,
    BubbleRouteError,
    Pages: Pages(ProtectedRoute),
  });

const stores = rootStore => [
  {
    serviceproviderCreateFormStore: new ServiceProviderCreateFormStore(
      rootStore,
    ),
  },
  { serviceproviderEditFormStore: new ServiceProviderEditFormStore(rootStore) },
  { serviceproviderListStore: new ServiceProviderListStore(rootStore) },
  {
    serviceproviderSearchFormStore: new ServiceProviderSearchFormStore(
      rootStore,
    ),
  },
];

export { ServiceProvidersList, CompanyInfoCreate, UsersList, routes, stores };
